import type { IGamAdUnit, IGamCreativeSize } from '@/Interfaces/Forecaster/GamInventory.interface';
import {
  FORECASTER_GAM_AD_UNITS_ENDPOINT,
  FORECASTER_GAM_CREATIVE_SIZES_ENDPOINT,
  FORECASTER_GAM_SUB_AD_UNITS_ENDPOINT,
} from '@/constants/endpoints';
import axios from 'axios';

export const getGamTopAdUnits = async (): Promise<IGamAdUnit[]> => {
  const { data } = await axios.get<IGamAdUnit[]>(FORECASTER_GAM_AD_UNITS_ENDPOINT);
  return data;
};

export const getGamSubAdUnits = async (topAdUnitId: string): Promise<IGamAdUnit[]> => {
  const { data } = await axios.get<IGamAdUnit[]>(FORECASTER_GAM_SUB_AD_UNITS_ENDPOINT(topAdUnitId));
  return data;
};

export const getGamCreativeSizes = async (): Promise<IGamCreativeSize[]> => {
  const { data } = await axios.get<IGamCreativeSize[]>(FORECASTER_GAM_CREATIVE_SIZES_ENDPOINT);
  return data;
};
